const errorFieldTypes = {
    required: 'required',
    minLength: 'minLength',
    maxLength: 'maxLength',
    notANumber: 'notANumber',
    versionFormat: 'versionFormat',
    dateFormat: 'dateFormat',
    numberBetween: 'numberBetween'
};

export default errorFieldTypes;
